import styled from "@emotion/styled";

export const ErrorParagraph = styled.p`
    color: ${({ theme }) => theme.palette.error.light};
    margin: 0;
    font-size: small;
`;